export const timeAllocationLevels = {
  GROUP: 'group',
  PERSON: 'person',
  TASK: 'task',
}
